import { useWhiteLabelling } from 'components/WhiteLabellingProvider';
import { ShippingMethod } from 'generated/graphql';
import useSearch from './useSearch';

// Honour an explicit shippingMethod URL param when present; otherwise fall back
// to the profile default (Direct for villa profiles, Hub for everyone else).
export const resolveDefaultShippingMethod = (
  paramMethod: string | undefined,
  isVillaProfile: boolean,
): ShippingMethod => (paramMethod as ShippingMethod) ?? (isVillaProfile ? ShippingMethod.Direct : ShippingMethod.Hub);

const useDefaultShippingMethod = () => {
  const { isVillaProfile } = useWhiteLabelling();
  const [getParam] = useSearch();
  return resolveDefaultShippingMethod(getParam('shippingMethod'), isVillaProfile);
};

export default useDefaultShippingMethod;
